import { useRouter } from "next/navigation";
import { MdPerson, MdLogout, MdAdminPanelSettings } from "react-icons/md";
import CustomDropDownMenu from "@components/FormFields/CustomDropDownMenu";
import useDialog from "@hooks/useDialog";
import { useAuth } from "@hooks/useAuth";
import { Button } from "@components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { UserImpersonation } from "@components/Admin/UserImpersonation";
import { PermissionGate } from "@components/shared/PermissionGate";

export default function ProfileIcon() {
  const router = useRouter();
  const { openDialog, closeDialog } = useDialog();
  const { signOut, user } = useAuth();

  if (!user?.id) return <></>;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost">
          <MdPerson className="" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        {user.email && <p className="pb-2 pl-2 pr-2 text-xs">{user.email}</p>}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            router.push("/profile");
          }}
        >
          <MdPerson />
          Profile
        </DropdownMenuItem>
        <PermissionGate has="admin:manage_admins" isSystem>
          <DropdownMenuItem
            onClick={() => {
              router.push("/admin/users");
            }}
          >
            <MdAdminPanelSettings />
            Manage Users
          </DropdownMenuItem>
        </PermissionGate>
        <PermissionGate has="admin:impersonate_user">
          <UserImpersonation />
          <DropdownMenuSeparator />
        </PermissionGate>
        <DropdownMenuItem
          onClick={() => {
            openDialog({
              title: "Log Out",
              description: "Are you sure you want to log out?",
              dialogType: "confirm",
              onConfirm: () => {
                closeDialog();
                signOut();
              },
            });
          }}
        >
          <MdLogout />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return (
    <CustomDropDownMenu
      menuButton={
        <Button size="icon" variant="ghost">
          <MdPerson className="" />
        </Button>
      }
      menuItems={[
        {
          items: [
            {
              title: "My Profile",
              icon: <MdPerson />,
              onClick: () => {
                router.push("/profile");
              },
            },
          ],
        },
        {
          items: [
            {
              title: "Logout",
              icon: <MdLogout />,
              onClick: () => {
                openDialog({
                  title: "Log Out",
                  description: "Are you sure you want to log out?",
                  dialogType: "confirm",
                  onConfirm: () => {
                    closeDialog();
                    signOut();
                  },
                });
              },
            },
          ],
        },
      ]}
    />
  );
}
